<!--单位信息模块-->
<template>
	<div class="dayInfoBody usePowerUnitDiv">
		<div class="topLeftTitleContent">统计信息</div>
		<div class="dayInfoContent bodyBorder">
			<div class="divbody">
				<div class="column">
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">配电房数量</p>
						<p class="usePowerUnitBoxInfo">{{roomCount}}</p>
					</div>
					<div class="usePowerUnitBlock" style="margin-bottom: 20%;">
						<p class="usePowerUnitBoxTitle" style="height: 40px;line-height: 40px;font-size: 14px;">负荷容量(kW)</p>
						<p class="usePowerUnitBoxInfo special" style="height: 50px;line-height: 50px;">{{loadCapacity}}</p>
					</div>
				</div>
				<div class="column">
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">负荷设备数</p>
						<p class="usePowerUnitBoxInfo">{{loadDeviceList.length}}</p>
					</div>
					<canvasCircle class="circle" color="#86e4f5" backgroundColor="#395667" :pvalue="realLoad" pcontent="实时负荷(kW)" :rate="realLoadRate"></canvasCircle>
				</div>
				<div class="column">
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">日最大需量(kW)</p>
						<p class="usePowerUnitBoxInfo">{{dayMaxNeed}}</p>
					</div>
					<canvasCircle class="circle" color="#ff7656" backgroundColor="#395667" :pvalue="dayMaxLoad" pcontent="日最大负荷(kW)" :rate="dayMaxRate"></canvasCircle>
				</div>
				<div class="column">
					<div class="usePowerUnitBlock">
						<p class="usePowerUnitBoxTitle">月最大需量(KW)</p>
						<p class="usePowerUnitBoxInfo">{{monthMaxNeed}}</p>
					</div>
					<canvasCircle class="circle" color="#ff9900" backgroundColor="#395667" :pvalue="monthMaxLoad" pcontent="月最大负荷(kW)" :rate="monthMaxRate"></canvasCircle>
				</div>
			</div>
			<div class="divbody">
				<vchart ref='vchartLine'></vchart>
			</div>
		</div>
	</div>
</template>

<script>
	import canvasCircle from '@/page/unitProfile/canvasCircle.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			canvasCircle,
			vchart,
		},
		props: [],
		data() {
			return {
				dayMaxNeed: 0,
				monthMaxNeed: 0,
				dayMaxLoad: 0,
				monthMaxLoad: 0,
				todayLoadLine: [],
				nowLoadDeviceFromname: "",
				loadDeviceList: [],
				deviceNoToArchivesInfo: {},
				lineOption: {
					xAxis: {
						type: 'category',
					},
					yAxis: {
						type: 'value'
					},
					series: []
				},
			}
		},
		created() {},
		mounted() {
			addNewTask("refreshUnitDayInfo", 0, 5 * 60 * 1000, -1, () => {
				this.getLoadValue(this.nowUnit.id)
			})
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.nowLoadDeviceFromname)
			removeTask("refreshUnitDayInfo")
		},
		computed: {
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			loadCapacity() {
				//总负荷容量,负荷设备是负荷配置中配置的当前单位的负荷设备，然后通过他们绑定的台账来查询额定容量属性
				var count = 0
				for (var i = 0, len = this.loadDeviceList.length; i < len; i++) {
					var item = this.loadDeviceList[i]
					var info = this.deviceNoToArchivesInfo[item.deviceno]
					if (!isempty(info) && !isempty(info.next)) {
						var target = info.next.find(it => it.propertyCode == "Capacity")
						if (!isempty(target) && !isempty(target.value)) {
							try {
								count += parseFloat(target.value)
							} catch (e) {}
						}
					}
				}
				return parseInt(count)
			},
			nowReadDeviceTree() {
				//当前单位可查看虚拟设备树
				return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(this.nowUnit.id)
			},
			roomCount() {
				//配电房数量，由当前单位下所有类型为配电房的虚拟设备组的数量决定，配电房下的配电房也算配电房
				var list = treeToList(this.nowReadDeviceTree, 'next', item => {
					return item.hasOwnProperty("next")
				})
				return list.filter(item => {
					return item.devicetype == 2
				}).length
			},
			realLoad() {
				var list = this.nowLoadDeviceFromname
				var values = this.realTimeValueStore.getters.getValue(list)
				var count = 0
				for (var i = 0, len = values.length; i < len; i++) {
					if (values[i] != undefined) {
						count += parseFloat(values[i])
					}
				}
				//实时负荷
				return (Math.round(count * Math.pow(10, 2))) / Math.pow(10, 2)
			},
			realLoadRate() {
				if (this.loadCapacity != 0 && this.realLoad != 0) {
					return cutDigital(this.realLoad / this.loadCapacity * 100)
				}
				return '0.00'
			},
			dayMaxRate() {
				var rate = '0.00'
				try {
					rate = cutDigital(this.dayMaxLoad / this.loadCapacity * 100)
					if (isempty(rate) || isNaN(rate)) {
						return '0.00'
					}
				} catch (e) {}
				return rate
			},
			monthMaxRate() {
				var rate = '0.00'
				try {
					rate = cutDigital(this.monthMaxLoad / this.loadCapacity * 100)
					if (isempty(rate) || isNaN(rate)) {
						return '0.00'
					}
				} catch (e) {}
				return rate
			},
			xList() {
				var list = []
				for (var h = 0, len = 24; h < len; h++) {
					for (var m = 0, lenm = 60; m < lenm; m += 5) {
						list.push((h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m)
					}
				}
				return list
			},
			getLine() {
				return {
					xAxis: {
						type: 'category',
						axisLabel: {
							interval: 23
						},
						data: this.xList,
					},
					yAxis: {
						type: 'value',
						name: '负荷值（kW）',
					},
					legend: {
						data: ['昨日负荷', '前日负荷', '今日负荷'],
						x: 'right',
						y: '10px',
						width: '20px',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					backgroundColor: '',
					grid: {
						height: '80%',
						left: '8%',
						right: '5%',
						bottom: '3%',
						containLabel: true
					},
					series: this.todayLoadLine
				}
			},
		},
		watch: {
			getLine(nv, ov) {
				this.$refs.vchartLine.setData(nv)
			},
			nowLoadDeviceFromname(nv, ov) {
				if (!isempty(ov)) {
					//移除旧变量
					this.realTimeValueStore.commit("removeKeys", ov)
				}
				if (!isempty(nv)) {
					this.realTimeValueStore.commit("addKeys", nv)
				}
			},
			nowUnit(nv, ov) {
				this.getLoadValue(nv.id)
			},
		},
		methods: {
			getLoadValue(unitId) {
				//获取单位相关的数据
				if (isempty(unitId)) {
					return
				}
				//获取变压器负荷设备列表
				this.$api.deviceApi.getDeviceListByDeviceType(unitId, 'load', respon => {
					this.loadDeviceList = respon
					this.$api.archivesApi.getArchivesInfoByVirtualDeviceNos(respon.map(item => item.deviceno).join(','), tree => {
						this.deviceNoToArchivesInfo = tree
					})
				})
				//查询月最大需量
				this.$api.powerApi.getMonthMaxLoadDemand(unitId, new Date().getTime(), respon => {
					this.monthMaxNeed = isempty(respon) ? '--' : respon
				})
				//查询日最大需量
				this.$api.powerApi.getDayMaxLoadDemand(unitId, new Date().getTime(), respon => {
					this.dayMaxNeed = isempty(respon) ? '--' : respon
				})
				//查询日最大负荷
				this.$api.powerApi.getDayMaxLoad(unitId, new Date().getTime(), respon => {
					this.dayMaxLoad = isempty(respon) ? '--' : respon
				})
				//查询月最大负荷
				this.$api.powerApi.getMonthMaxLoad(unitId, new Date().getTime(), respon => {
					this.monthMaxLoad = isempty(respon) ? '--' : respon
				})
				//获取实时负荷
				this.$api.powerApi.getLoadFromnameByUnitId(unitId, respon => {
					this.nowLoadDeviceFromname = isempty(respon) ? '--' : respon
				})
				//获取当日负荷曲线
				var ser = []
				this.$api.powerApi.getUnitDayLoadValues(unitId, new Date(getDay(-2) + ' 00:00:00').getTime(), respon => {
					ser.push({
						data: respon,
						type: 'line',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						name: '前日负荷'
					})
				})
				this.$api.powerApi.getUnitDayLoadValues(unitId, new Date(getDay(-1) + ' 00:00:00').getTime(), respon => {
					ser.push({
						data: respon,
						type: 'line',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						name: '昨日负荷'
					})
				})
				this.$api.powerApi.getUnitDayLoadValues(unitId, new Date(getDay(0) + ' 00:00:00').getTime(), respon => {
					ser.push({
						data: respon,
						type: 'line',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						name: '今日负荷'
					})
				})
				this.todayLoadLine = ser
			},
		}
	}
</script>

<style scoped>
	@import url("../../../components/css/usePowerUnit.css");
	.divbody>>>.default-chart {
		height: 100%;
		width: 100%;
	}

	.dayInfoBody {
		height: 240px;
	}


	.dayInfoContent {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: calc(100% - 31px);
	}

	.divbody {
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 48.5%;
		height: calc(100% - 20px);
	}

	.column {
		width: 23.5%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}

	.info {
		font-size: 16px;
		font-family: "黑体";
	}

	.circle {
		width: 100%;
	}
</style>
